module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAAASBJREFUaEPtWG0OwiAM7U6m3kxPpjfTNJGkWYA8ymDAHn8t0PdR2rnJ5GubPH8hgLMVpAJXVeAuIu8/+I+IPLxEnGUhAgiKLa3A1+vLxD7rdWsh9Joo2TkFCGBHbXcFUGk9cXyFLvEKeayB7lnCQhasFrhr1TayMM/o5S8RcSfiyl6k+oNGAagddOlARgClShxhoWEVeGbYCGOGJh8DkNtbSrLepURHzzxyFrI1YGujNOFUfPNhbjgAiA1uHSwUFCm2ECI9n1GEpVzM0s8oQo71pXbh6TpxCmToDeH3ZsBqLZQC0K24CSAhARVAXhCN4SxkmBpuFir9Z244AKgNY3EsYpQ99oFV+wDqgOq4VhaqTgw9gABQplrFUYFWzKLn/gCdzVIxlWJ7kwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/awayFormationChange.png
// module id = 0MSS
// module chunks = 79